import axios from "axios";
import { MAIN_API } from "./apilist";
import { store } from "../redux/store/store";

/* Zoco Chat desde el organizador: /api/organizer/chat/*. Solo el dueño (el back responde 403 al resto).
   El negocio sale del token de Zoco; el front nunca lo manda. */
const BASE = MAIN_API + "/api/organizer/chat";
const authHeader = () => ({ Authorization: `Bearer ${store.getState().auth.accessToken}` });

// Workspaces del negocio: `info: [{ workspaceId, nombre, whatsappConectado }]`
export const chatListWorkspacesApi = () => axios.get(`${BASE}/workspaces`, { headers: authHeader() });
// Plantillas de WhatsApp: `info: [{ id, name, category, language, status, bodyText, variableCount, rejectionReason }]`
export const chatListTemplatesApi = (workspaceId) =>
  axios.get(`${BASE}/workspaces/${encodeURIComponent(workspaceId)}/templates`, { headers: authHeader() });
// Crea una plantilla (es_AR) y la manda a Meta: `info: { templateId, status, category }`.
// Sin `category` el back la crea de utilidad (recordatorios); las campañas mandan "MARKETING".
export const chatCreateTemplateApi = (workspaceId, { name, body, footer, category }) =>
  axios.post(
    `${BASE}/workspaces/${encodeURIComponent(workspaceId)}/templates`,
    { name, body, ...(footer ? { footer } : {}), ...(category ? { category } : {}) },
    { headers: authHeader() },
  );
